import(/* webpackMode: "eager" */ "/home/node/app/node_modules/@mui/material/Container/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ProductWrap","ProductAside","StickyBox"] */ "/home/node/app/src/app/[locale]/(header-footer)/product/[slug]/layout.styled.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/components/BreadcrumbsWrap/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/containers/StillNeedHelp/index.tsx");
